import { useContext } from "react";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { updatedPaymentMethods } from "../../../constants";
import { LanguageContext } from "../../../context/LanguageContext";
import styles from "./styles.module.css";

const PaymentMethodToggle = ({
  visible = true,
  value = null,
  onChange,
  idPrefix = "",
  options = updatedPaymentMethods,
}) => {
  const [I18n] = useContext(LanguageContext);
  const selectedValue =
    typeof value === "string"
      ? value
      : value?.name || value?.type || null;

  return (
    <div
      className={`${styles.reveal} ${visible ? styles.revealVisible : ""}`}
      aria-hidden={!visible}
    >
      <div className={styles.revealInner}>
        <ToggleButtonGroup
          value={selectedValue}
          exclusive
          onChange={(_, newValue) => {
            if (!newValue) return;
            const method =
              options.find((m) => m.name === newValue) || null;
            onChange?.(method);
          }}
          aria-label="payment method"
          className={styles.toggleGroup}
          data-selected={selectedValue || "bank"}
        >
          {options.map((item) => (
            <ToggleButton
              key={item.name}
              id={idPrefix ? `${idPrefix}_${item.name}` : item.name}
              value={item.name}
            >
              {I18n[item.name] || item.display_name}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
      </div>
    </div>
  );
};

export default PaymentMethodToggle;
